module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afoot55-792d90ea75f31695f5103c68f083090d.jpg";